import { autoinject, bindable } from 'aurelia-framework';
import { ScopeTypeGroup, ScopeTypeGroupService } from './scope-type-group-service';

@autoinject
export class ScopeTypeGroupSelect {
	@bindable selectedScopeTypeGroup: string;
	@bindable groups: ScopeTypeGroup[];

    constructor(private groupService: ScopeTypeGroupService) {}

    attached() {
        this.groupService.getScopeTypeGroups()
			.then((groups) => {
				this.groups = groups;
	        });
    }

    get scopeTypeGroups() {
        return this.groupService.scopeTypeGroups;
    }
}
